import React from 'react';
import { motion } from 'framer-motion';
import { FaShieldAlt, FaRobot, FaClock } from 'react-icons/fa';

const HeroSection = () => {
  const handleBookDemo = () => {
    window.open('https://calendly.com/contact-apexlegalsystems/30min', '_blank');
  };

  return (
    <section className="relative pt-32 pb-20 px-4 sm:px-6 lg:px-8 overflow-hidden" id="hero">
      {/* Background gradient effects */}
      <div className="absolute inset-0 overflow-hidden">
        <div className="absolute top-0 left-1/4 w-96 h-96 bg-emerald-500/10 rounded-full blur-3xl"></div>
        <div className="absolute bottom-0 right-1/4 w-96 h-96 bg-emerald-500/10 rounded-full blur-3xl"></div>
      </div>

      <div className="relative max-w-7xl mx-auto">
        <div className="grid lg:grid-cols-1 gap-12 items-center">
          {/* Center Content */}
          <motion.div
            initial={{ opacity: 0, y: 50 }}
            animate={{ opacity: 1, y: 0 }}
            transition={{ duration: 0.8 }}
            className="text-center"
          >
            <motion.div
              initial={{ opacity: 0, y: 20 }}
              animate={{ opacity: 1, y: 0 }}
              transition={{ delay: 0.2 }}
              className="inline-block bg-emerald-500/10 border border-emerald-500/30 rounded-full px-4 py-2 mb-6"
            >
              <span className="text-emerald-400 font-semibold">AI-Powered Legal Intake</span>
            </motion.div>

            <motion.h1
              initial={{ opacity: 0, y: 20 }}
              animate={{ opacity: 1, y: 0 }}
              transition={{ delay: 0.3 }}
              className="text-5xl md:text-6xl lg:text-7xl font-bold mb-6 leading-tight"
            >
              Stop Losing{' '}
              <span className="gradient-text">$144,000 a Year</span>{' '}
              to Missed Calls
            </motion.h1>

            <motion.p
              initial={{ opacity: 0, y: 20 }}
              animate={{ opacity: 1, y: 0 }}
              transition={{ delay: 0.4 }}
              className="text-xl text-gray-300 mb-8 leading-relaxed max-w-4xl mx-auto"
            >
              The 24/7 AI-powered intake system that answers every call, qualifies every lead, and books consultations while you sleep.
            </motion.p>

            <motion.p
              initial={{ opacity: 0, y: 20 }}
              animate={{ opacity: 1, y: 0 }}
              transition={{ delay: 0.5 }}
              className="text-lg text-gray-400 mb-10"
            >
              Built for PI firms. HIPAA-compliant from day one.
            </motion.p>

            <motion.div
              initial={{ opacity: 0, y: 20 }}
              animate={{ opacity: 1, y: 0 }}
              transition={{ delay: 0.6 }}
              className="flex flex-col sm:flex-row gap-4 mb-12 justify-center"
            >
              <button
                onClick={handleBookDemo}
                className="bg-emerald-500 hover:bg-emerald-600 text-slate-900 font-bold px-8 py-4 rounded-lg transition-all hover:scale-105 shadow-lg shadow-emerald-500/30 text-lg"
                data-testid="hero-demo-button"
              >
                Book a Discovery Call
              </button>
              <button
                onClick={() => document.getElementById('how-it-works').scrollIntoView({ behavior: 'smooth' })}
                className="border-2 border-slate-600 hover:border-emerald-500 text-white font-bold px-8 py-4 rounded-lg transition-all hover:scale-105 text-lg"
              >
                See How It Works
              </button>
            </motion.div>

            {/* Trust Badges */}
            <motion.div
              initial={{ opacity: 0 }}
              animate={{ opacity: 1 }}
              transition={{ delay: 0.8 }}
              className="grid grid-cols-3 gap-6 max-w-3xl mx-auto"
            >
              <div className="flex flex-col items-center text-center">
                <FaShieldAlt className="text-emerald-400 text-3xl mb-2" />
                <span className="text-sm text-gray-400 font-semibold">HIPAA Compliant</span>
              </div>
              <div className="flex flex-col items-center text-center">
                <FaRobot className="text-emerald-400 text-3xl mb-2" />
                <span className="text-sm text-gray-400 font-semibold">AI Receptionist Included</span>
              </div>
              <div className="flex flex-col items-center text-center">
                <FaClock className="text-emerald-400 text-3xl mb-2" />
                <span className="text-sm text-gray-400 font-semibold">Live in 7-14 Days</span>
              </div>
            </motion.div>
          </motion.div>
        </div>
      </div>
    </section>
  );
};

export default HeroSection;
